import { StyledNetceteraLogo } from "components/core/logo/NetceteraLogo";
import React from "react";
import { WupLogo } from "components/core/logo/WupLogo";
import { LogoContainer, StyledLink, SvgContainer } from "components/core/logo/LogoLinkContainer.styles";
import { Typography } from "@mui/material";

export interface LogoLinkContainerProps {
  href: string;
  text: string;
  type: "NETCETERA" | "WUP";
}

export const LogoLinkContainer: React.FC<LogoLinkContainerProps> = ({ href, text, type }) => {
  return (
    <LogoContainer>
      <StyledLink color="inherit" href={href}>
        <Typography variant="body2" color="textSecondary" align="center">
          {text}
        </Typography>
        <SvgContainer>
          {type === "NETCETERA" && <StyledNetceteraLogo />}
          {type === "WUP" && <WupLogo />}
        </SvgContainer>
      </StyledLink>
    </LogoContainer>
  );
};
